import { ICON_COLORS } from '@constants/colors.ts';
import { DESKTOP_SIZES, FONT_FAMILY, SIZES } from '@constants/fonts.ts';
import styled from 'styled-components';

export const LockedTimeSection = styled.div`
    color: ${ICON_COLORS.primary};
    ${FONT_FAMILY.poppins};
    ${DESKTOP_SIZES[SIZES.BODY_SM].fontSize}
    ${DESKTOP_SIZES[SIZES.BODY_SM].lineHeight}
    ${DESKTOP_SIZES[SIZES.BODY_SM_BOLD].fontWeight};
`;
